import { TICKET_TYPES } from "@circle-react/components/Events/CompassEventModal/constants";
import {
  EVENT_TYPES,
  LOCATION_TYPES,
  STATUS,
} from "@circle-react/components/Events/helpers/constants";
import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { ROOM_ACCESS_TYPES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Event } from "@circle-react/types/Event";

import { t } from "@/i18n-js/instance";

export const SECTIONS = {
  overview: "overview",
  people: "people",
  basicInfo: "basicInfo",
  details: "details",
  notifications: "notifications",
  email: "email",
  advancedOptions: "advancedOptions",
} as const;

export type Section = (typeof SECTIONS)[keyof typeof SECTIONS];

const isLiveStream = (event: Event | null) =>
  event?.event_setting_attributes?.location_type === LOCATION_TYPES.LIVE_STREAM;

export const isPublicStream = (event: Event | null) =>
  isLiveStream(event) &&
  event?.event_setting_attributes?.live_stream_room_setting_attributes
    ?.access_type === ROOM_ACCESS_TYPES.PUBLIC_STREAM;

export const isPaidEvent = (event: Event | null) =>
  event?.event_setting_attributes?.ticket_type == TICKET_TYPES.PAID;

const isRecurring = (event: Event | null) =>
  event?.event_type === EVENT_TYPES.RECURRING;

const isDraft = (event: Event | null) => event?.status === STATUS.DRAFT;

const hasEventEnded = (event: Event | null) =>
  Boolean(event && dateIsPast(event?.event_setting_attributes?.ends_at));

const isPastOrDraft = (event: Event | null) =>
  hasEventEnded(event) || isDraft(event);

export const eventDeletionMessage = (event: Event | null) => {
  const isRecurringEvent = isRecurring(event);
  let message = isRecurringEvent
    ? t("events.recurring_deletion_successful")
    : t("event_dropdown_actions.delete_successful");
  if (isPastOrDraft(event)) {
    message = isRecurringEvent
      ? t("events.recurring_draft_deletion_successful")
      : t("event_dropdown_actions.draft_delete_successful");
  }
  return message;
};
